export default __webpack_public_path__ + "static/media/answers_single.12f7f4c6.svg";